import styled from "@emotion/styled";
import { StyledSignupButton as EmailFormSubmitButton } from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/email-form/styles";
import { SubmitButton as SignUpButton } from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/sign-up-button/styles";
import { IconContainer as SocialButtonIconContainer } from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/social-buttons/styles";
import {
  AgreementCheckboxContainer as SignUpAgreementCheckboxContainer,
  AgreementContainer as SignUpAgreementContainer,
  AgreementDescription as SignUpAgreementDescription,
  Container as SignUpNewsletterContainer,
  TermAndConditionContainer as SignUpTermAndConditionContainer,
  TermAndConditionLink as SignUpTermAndConditionLink,
} from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/styles";
import {
  CheckEmailMessage as SignUpSuccessCheckEmailMessage,
  Container as SignUpSuccessMessageContainer,
  Title as SignUpSuccessMessageTitle,
  StyledFollowUsOnFacebook,
} from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-success-message/styles";
import { Container as NewsletterContainer } from "scmp-sdk/components/newsletter/newsletter-widget/styles";
import type { ThemeType } from "scmp-sdk/components/newsletter/newsletter-widget/types";

import { fontRoboto } from "shared/lib/styles";

export const theme: ThemeType = {
  findOutMore: {
    titleFontStyle: "small",
  },
  hasSummaryLine: false,
  hasTitle: false,
  newsletterIcon: {
    icon: "white",
  },
  orientation: "portrait",
  root: {
    containerSize: "medium",
  },
  signUpNewsletter: {
    checkboxStyle: "primary",
    hasSummary: false,
    summaryFontStyle: "small",
    titleFontStyle: "small",
  },
  signUpSuccess: {
    checkEmailMessageStyle: "gray",
    hasCheckEmail: true,
    hasSeeMoreLinks: false,
    titleFontStyle: "medium",
  },
};

export const Container = styled.div`
  ${NewsletterContainer} {
    max-inline-size: 100%;
  }

  ${SignUpNewsletterContainer} {
    justify-items: center;

    text-align: start;

    ${SocialButtonIconContainer} {
      background-color: #ffffff;
    }

    ${SignUpAgreementDescription}, ${SignUpTermAndConditionLink}, ${SignUpTermAndConditionContainer} {
      color: #ffffff;
      line-height: 12px;
      text-align: center;
    }

    ${SignUpButton} {
      min-inline-size: 240px;

      color: #001246;
      font-size: 14px;
      font-family: ${fontRoboto};

      background-color: #ffca05;
    }

    ${SignUpAgreementContainer} {
      align-items: center;

      ${SignUpAgreementDescription} {
        max-inline-size: 278px;

        line-height: 13px;
        text-align: start;

        opacity: 0.7;
      }

      ${SignUpAgreementCheckboxContainer} {
        display: flex;
        svg {
          color: #ffffff;

          background-color: #ffffff;
        }
      }
    }

    ${EmailFormSubmitButton} {
      min-inline-size: 86px;
    }
  }

  ${SignUpSuccessMessageContainer} {
    justify-content: center;

    color: #ffca05;
    text-align: start;
    ${SignUpSuccessMessageTitle} {
      font-size: 21px;
      line-height: 27px;
      text-align: center;
    }

    ${SignUpSuccessCheckEmailMessage} {
      color: #ffca05;
      font-size: 16px;
      text-align: center;
    }

    ${StyledFollowUsOnFacebook} {
      align-items: center;
    }
  }
`;
